import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from '../../services/analytics-data.service';
import { UnsubscribeService } from 'src/app/services/unsubscribe.service';
import { takeUntil } from 'rxjs';
import { RequestsDataDto } from '../../models/analytics.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-requests-analytics',
  templateUrl: './requests-analytics.component.html',
  styleUrls: ['./requests-analytics.component.scss'],
  providers: [UnsubscribeService],
})
export class RequestsAnalyticsComponent implements OnInit {
  requestData: RequestsDataDto[] = [];

  constructor(
    private analyticsService: AnalyticsService,
    private unsubscribe$: UnsubscribeService,
    public router: Router
  ) {}

  ngOnInit() {
    this.loadData();
  }

  private loadData() {
    this.analyticsService
      .getRequestsAnalytics()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (res) => {
          this.requestData = res;
        },
      });
  }
}
